import { useMemo } from 'react';

export const defaultProps = {
  container: { backgroundColor: 'HEXCOLOR', hexColor: '#eeeeee' },
  title: {
    text: '< Horizontal Banner />',
    groupButton: { bold: true, center: true },
    textSize: 'default',
    margin: {
      currency: {
        bottom: '0.5rem',
      },
    },
  },
  subtitle: {
    text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
      eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
      ad minim veniam, quis nostrud exercitation ullamco laboris`,
    textSize: 'large',
    textType: 'text',
    groupButton: { center: true },
  },
  actionButton: {
    buttonType: 'custom',
    buttonText: 'Click here',
    alignment: 'center',
  },
};

export const useHorizontalBanner = ({
  title,
  subtitle,
  container,
  actionButton,
  disableDefaultProps,
}) => {
  const titleProps = useMemo(
    () => ({
      ...title,
      text:
        !disableDefaultProps && !title?.text
          ? defaultProps.title.text
          : title?.text,
      groupButton:
        !disableDefaultProps && !title?.groupButton
          ? defaultProps?.title.groupButton
          : title?.groupButton,
      textSize:
        !disableDefaultProps && !title?.textSize
          ? defaultProps.title.textSize
          : title?.textSize,
      margin:
        !disableDefaultProps && !title?.margin?.currency?.bottom
          ? defaultProps.title.margin
          : title?.margin,
    }),
    [disableDefaultProps, title]
  );

  const subtitleProps = useMemo(
    () => ({
      ...subtitle,
      text:
        !disableDefaultProps && !subtitle?.text
          ? defaultProps.subtitle.text
          : subtitle?.text,
      groupButton:
        !disableDefaultProps && !subtitle?.groupButton
          ? defaultProps?.subtitle.groupButton
          : subtitle?.groupButton,
      textSize:
        !disableDefaultProps && !subtitle?.textSize
          ? defaultProps.subtitle.textSize
          : subtitle?.textSize,
      textType:
        !disableDefaultProps && !subtitle?.textType
          ? defaultProps.subtitle.textType
          : subtitle?.textType,
    }),
    [disableDefaultProps, subtitle]
  );

  const containerProps = useMemo(
    () =>
      !disableDefaultProps
        ? {
            ...container,
            backgroundColor:
              container?.backgroundColor ||
              defaultProps.container.backgroundColor,
            hexColor: container?.hexColor || defaultProps.container.hexColor,
          }
        : container,
    [disableDefaultProps, container]
  );

  const actionButtonProps = useMemo(
    () =>
      !disableDefaultProps
        ? {
            ...actionButton,
            buttonType:
              actionButton?.buttonType || defaultProps.actionButton.buttonType,
            buttonText: !actionButton?.buttonText
              ? defaultProps.actionButton.buttonText
              : actionButton?.buttonText,
            alignment:
              actionButton?.alignment || defaultProps?.actionButton.alignment,
          }
        : actionButton,
    [actionButton, disableDefaultProps]
  );
  return {
    titleProps,
    subtitleProps,
    containerProps,
    actionButtonProps,
  };
};
